export type TOscillatorType = 'custom' | 'sawtooth' | 'sine' | 'square' | 'triangle';
